import React, { useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IMG_BASE_URL } from '../../../../config/Config';

const Our_Celebrity = ({ data }) => {
    const our_celebrity_list = data?.our_celebrity;
    const [isOpen_Custom_video, set_Is_Open_Custom_Video] = useState(false);
    const [activeVideo, setActiveVideo] = useState(null);

    const Handle_Is_Open_Custom_video = (videoUrl) => {
        setActiveVideo(videoUrl);
        set_Is_Open_Custom_Video(!isOpen_Custom_video);
    };

    const getYouTubeVideoId = (url) => {
        const match = url?.match(/(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&\s]+)/)
            || url?.match(/(?:https?:\/\/)?(?:www\.)?youtu\.be\/([^&\s]+)/);
        return match ? match[1] : '';
    };

    const slidesToShow = our_celebrity_list?.length < 4 ? our_celebrity_list?.length : 4;

    const settings = {
        infinite: our_celebrity_list?.length > slidesToShow,
        speed: 500,
        slidesToShow,
        slidesToScroll: 1,
        autoplay: our_celebrity_list?.length > 1,
        autoplaySpeed: 5000,
        arrows: our_celebrity_list?.length > 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: our_celebrity_list?.length < 3 ? our_celebrity_list?.length : 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: our_celebrity_list?.length < 2 ? our_celebrity_list?.length : 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <>
            <section className="gi-deal-section py-[40px] wow fadeInUp" data-wow-duration="2s">
                <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1200px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[770px] min-[576px]:max-w-[560px]">
                    <div className="w-full">
                        <div className="section-title" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200">
                            <div className="gi-tab-title w-full text-center">
                                <h2 className="bodonibook_font text-3xl text-gray-900 font-bold capitalize">
                                    Our Celebrity Customers
                                </h2>
                            </div>
                        </div>

                        <div className="gi-deal-block z-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                            <Slider {...settings} className="w-full">
                                {our_celebrity_list?.map((our_celebrity_result, index) => (
                                    <div className="px-3 py-3 lg:py-6" key={index}>
                                        <div className="celebritylist bg-white rounded-lg overflow-hidden shadow-custome my-4">
                                            <div
                                                className="gi-products text-center relative">
                                                <img className='aspect-[calc(4*3+1)/10] object-cover w-full mx-auto' src={`${IMG_BASE_URL}${our_celebrity_result?.image}`} alt='' />
                                                <div className="absolute inset-0 flex items-center justify-center h-full">
                                                    <button onClick={() => Handle_Is_Open_Custom_video(our_celebrity_result?.youtube_url)} className="size-18 rounded-full bg-radial-[at_50%_75%] from-sky-200 via-blue-400 to-indigo-900 to-90% outline-0 cursor-pointer m-auto">
                                                        <i className="fi-brands-youtube text-red-500 text-4xl" />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="celebritytitle px-5 py-4">
                                                <h3 className="gi-pro-stitle text-gray-900 text-sm font-semibold capitalize text-center line-clamp-1">
                                                    {our_celebrity_result?.title}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>

            {/* Modal */}
            {isOpen_Custom_video && activeVideo && (
                <div className="fixed inset-0  z-10 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white absolute top-[20%] rounded-lg shadow-lg w-[600px] max-w-full">
                        <div className="flex justify-between items-center p-3">
                            <h2 className="text-lg font-semibold text-gray-800">Our Celebrity Video</h2>
                            <button
                                className="text-[#9F2225] hover:text-gray-800 text-[25px]"
                                onClick={() => Handle_Is_Open_Custom_video(null)}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="text-gray-700">
                            <div className="youtube-video-container">
                                <iframe
                                    width="100%"
                                    height="400"
                                    src={`https://www.youtube.com/embed/${getYouTubeVideoId(activeVideo)}`}
                                    title="YouTube video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Our_Celebrity;
